import { useEffect, useRef } from 'react';
import { loadGradeHubSession } from '../../../lib/gradeHub/session';

type GradeSessionRestoreProps = {
  courseId?: string;
  assignmentId?: string;
  visibleIndexes: number[];
  hasFocus: boolean;
  onRestore: (payload: { focusIndex: number; draftScore: string; draftFeedback: string }) => void;
};

/** Restores queue focus and draft fields after interruption (local session snapshot). */
export function GradeSessionRestore({
  courseId,
  assignmentId,
  visibleIndexes,
  hasFocus,
  onRestore,
}: GradeSessionRestoreProps): null {
  const restored = useRef(false);

  useEffect(() => {
    if (restored.current || hasFocus || !courseId || !assignmentId) return;
    const snap = loadGradeHubSession(courseId, assignmentId);
    if (!snap || snap.focusIndex === null) return;
    if (!visibleIndexes.includes(snap.focusIndex)) return;
    restored.current = true;
    onRestore({
      focusIndex: snap.focusIndex,
      draftScore: snap.draftScore,
      draftFeedback: snap.draftFeedback,
    });
  }, [courseId, assignmentId, visibleIndexes, hasFocus, onRestore]);

  return null;
}
